import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { errorHelper } from '../../../utils/tools';
import { formValues } from './validationSchema';

import { Form, Row, Col, Button } from 'react-bootstrap';

import { addContainer, fetchContainers, checkContainerExists } from '../../../store/actions/container';
import CustomModal from '../../../hoc/customModal';

const AddContainer = ({ isVisible, onClose }) => {
    const notifications = useSelector(state => state.notifications);
    const currentBranch = useSelector(state => state.branch.current);

    const dispatch = useDispatch();
    const [isChecking, setIsChecking] = useState(false);
    
    const formik = useFormik({
        initialValues: formValues,
        validationSchema: Yup.object({
            container: Yup.string()
                .required('Názov nádoby je povinný')
                .min(3, 'Názov nádoby musí mať minimálne 3 znaky')
                .max(16, 'Názov nádoby môže mať maximálne 16 znakov')
                .test('checkDuplicateContainer', 'Nádoba s týmto názvom už existuje', async (value) => {
                    if (!value) return true;
                    setIsChecking(true);
                    try {
                        const result = await dispatch(checkContainerExists({ branchId: currentBranch, container: value })); 
                        const exists = result.payload;
                        return !exists; // Ak exists je true, vráti false, čo spôsobí chybu
                    } catch (error) {
                        console.error('Error checking container:', error);
                        return false;
                    } finally {
                        setIsChecking(false);
                    }
                })
        }),
        onSubmit: (values) => {
            handleSubmit(values);
        },
        validateOnChange: true,
        validateOnBlur: true,
    });

    // Reset form on success notification
    useEffect(() => {
        if (notifications && notifications.global.success) {
            formik.resetForm();
        }
    }, [notifications, formik]);

    const handleSubmit = (values) => {
        if (currentBranch !== '')
            values.branchId = currentBranch;
        
         // Send data
         dispatch(addContainer(values))
         .then(() => {
             if (currentBranch !== '') {
                 dispatch(fetchContainers(currentBranch));
             }
            // Close modal
             onClose();
         })
         .catch(error => {
             console.error("Error adding container:", error);
         });
    };

 

    return (
        <CustomModal isVisible={isVisible} onClose={onClose}>
            <Form onSubmit={formik.handleSubmit}>
                <h2>Pridať nádobu</h2>
                <hr />
                <Row>
                    <Form.Group className="mb-3" controlId="formBasicContainer">
                        <Form.Label>Názov nádoby</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Názov nádoby:"
                            {...formik.getFieldProps('container')}
                            isInvalid={formik.touched.container && formik.errors.container}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formik.errors.container}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Row>
                <Row className="mt-3">
                    <hr />
                    <Col className="d-flex justify-content-end">
                        <Button
                            className='button-custom-large'
                            variant='primary'
                            type="submit"
                        >
                            Pridať nádobu
                        </Button>
                    </Col>
                </Row>
            </Form>
        </CustomModal>
    );
};

export default AddContainer;